const _excluded = ["disabled", "loading", "icon", "iconPosition", "iconClassName", "tooltipPlacement", "className", "isImmutableUnderReview", "storeIsUnderReviewField", "showLoadingText", "tooltipText", "iconStyles"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Button as RBButton, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
export function Button(_ref) {
  let {
      disabled,
      loading,
      icon,
      iconPosition,
      iconClassName,
      tooltipPlacement = 'top',
      className = '',
      isImmutableUnderReview = false,
      storeIsUnderReviewField = 'isUnderTechnicalReview',
      showLoadingText = true,
      tooltipText = null,
      iconStyles = {}
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const isUnderTechnicalReview = useSelector(state => state.review[storeIsUnderReviewField]);
  const isDisabled = isImmutableUnderReview ? disabled || isUnderTechnicalReview : disabled;
  let content = loading && showLoadingText ? 'Working...' : props.children;
  if (icon) {
    const iconElement = /*#__PURE__*/React.createElement("span", {
      className: "material-icons md-18"
    }, loading ? 'pending' : icon);
    if (iconPosition === 'right') {
      content = /*#__PURE__*/React.createElement(React.Fragment, null, content, " ", iconElement);
    } else if (iconPosition === undefined || iconPosition === 'left') {
      content = /*#__PURE__*/React.createElement(React.Fragment, null, iconElement, " ", content);
    } else {
      throw new Error("Unsupported iconPosition: ".concat(iconPosition, "."));
    }
  }
  const button = () => {
    // Disabling a button does not work well if the "as" property is a link. Since its disabled anyway, we can just remove the "as" property.
    if (props.as === Link && isDisabled) {
      props.as = undefined;
    }
    // Bootstrap and Ayming Design System buttons have different style names
    // So when you want to use style from design system, here's the mapping: Ayming style = Bootstrap style
    // primary = primary | default = outline-primary | text = text
    return /*#__PURE__*/React.createElement(RBButton, _extends({
      className: "".concat(isDisabled ? 'cursor-disabled' : '', " ").concat(className)
    }, props, {
      disabled: isDisabled || loading
    }), content);
  };
  const buttonWithTooltip = () => {
    const tooltipTrigger = isDisabled ? /*#__PURE__*/React.createElement("span", {
      className: "d-inline-block w-auto"
    }, button()) : button();
    return /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: tooltipPlacement,
      overlay: /*#__PURE__*/React.createElement(Tooltip, null, tooltipText)
    }, tooltipTrigger);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!tooltipText && !loading ? buttonWithTooltip() : button());
}